import { createContext, use } from "react";
import type { IModalContextType } from "./types";

export const ModalContext = createContext<IModalContextType>(
  {} as IModalContextType,
);

export const useModalContext = () => {
  return use(ModalContext);
};
